/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-trailing-spaces */
import React from 'react';
import { Link } from 'react-router-dom';
import './css/Footer.css';
import PayAlfa from '../../images/pay-alfa.png';
import payApple from '../../images/pay-apple.png';
import PayBel from '../../images/pay-bel.png';
import PayBelcard from '../../images/pay-belcard.png';
import PayIdCheck from '../../images/pay-id-check.png';
import PayMaster from '../../images/pay-mastercard.png';
import PaySamsung from '../../images/pay-samsung.png';
import PayVisaSecure from '../../images/pay-visa-secure.png';
import PayVisa from '../../images/pay-visa.png';
import PayYa from '../../images/pay-ya.png';
import { getCurrentYear } from '../../Utils/DateUtil';
import { TOUR_HUNTER } from '../../Utils/Constants/FooterConstants';
import {
  PHONE_NUMBER,
  CONSULT_HOURS_DESC,
  CONSULT_HOURS,
} from '../../Utils/Constants/GlobalConstants';

import Insta from '../../images/instagram-r.svg';
import Telegram from '../../images/telegram-r.svg';

function Footer() {
  function scrollTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  return (
    <footer className="footer">
      <div className="containerW">
        <div className="footer_content">
          <div className="footer_row">
            <div className="footer_collunm">
              <div className="footer_text opacity08">Мы на связи</div>
              <div className="footer_phone mb_10">{PHONE_NUMBER}</div>
              <div className="wr_text_12 mb_5">{CONSULT_HOURS_DESC}</div>
              <div className="wr_text_12 mb_40">
                24/7 - поддержка действующих клиентов
              </div>
              <div className="footer_text opacity08 mb_15">
                Мы в социальных сетях
              </div>
              <div className="footer_social_w">
                <Link
                  target="_blank"
                  to="https://www.instagram.com/tourhunter.by"
                  className="footer_social"
                >
                  <img src={Insta} alt="" />
                </Link>
                <Link
                  target="_blank"
                  to="https://t.me/tourhunterby"
                  className="footer_social"
                >
                  <img src={Telegram} alt="" />
                </Link>
              </div>
            </div>
            <div className="footer_collunm">
              <div className="footer_row footer_first_row">
                <div className="footer_collunm">
                  <div className="footer_title_text mb_25">Компания</div>
                  <div className="mb_10">
                    <Link
                      to="/about"
                      className="footer_text opacity08"
                      onClick={scrollTop}
                    >
                      О нас
                    </Link>
                  </div>
                  <div className="mb_10">
                    <Link
                      to="/blog/"
                      target="_blank"
                      className="footer_text opacity08"
                    >
                      Блог
                    </Link>
                  </div>
                  <div className="mb_10">
                    <Link
                      to="/contacts/"
                      className="footer_text opacity08"
                      onClick={scrollTop}
                    >
                      Контакты
                    </Link>
                  </div>
                  <div className="mb_10">
                    <Link
                      to="/faq/"
                      className="footer_text opacity08"
                      onClick={scrollTop}
                    >
                      Часто задаваемые вопросы
                    </Link>
                  </div>
                </div>
                <div className="footer_collunm">
                  <div className="footer_title_text mb_25">Информация</div>
                  <div className="mb_10">
                    <Link
                      to="/file/oferta.pdf"
                      className="footer_text opacity08"
                      target="_blank"
                    >
                      Публичный договор
                    </Link>
                  </div>
                  <div className="mb_10">
                    <Link
                      to="/file/pravila.pdf"
                      className="footer_text opacity08"
                      target="_blank"
                    >
                      Правила оплаты
                    </Link>
                  </div>
                  <div className="mb_10">
                    <Link
                      to="/file/politika.pdf"
                      className="footer_text opacity08"
                      target="_blank"
                    >
                      Политика в отношении обработки персональных данных
                    </Link>
                  </div>
                  <div className="mb_10">
                    <Link
                      to="/file/soglashenie.pdf"
                      className="footer_text opacity08"
                      target="_blank"
                    >
                      Соглашение об обработке персональных данных
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer_row footer_second_row mb_30">
            <div className="footer_collunm">
              <div className="footer_lagal_info">
                <p className="footer_small_text opacity05">
                  ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ НОВИК НАТАЛЬЯ СТАНИСЛАВОВНА
                </p>
                <p className="footer_small_text opacity05">
                  220081, Республика Беларусь, д. Копище, ул. Братьев Райт 7,
                  оф. 92
                </p>
                <p className="footer_small_text opacity05">
                  Свидетельство о государственной регистрации №692232544, выдано
                  Минским райисполкомом 23.10.2023 г.
                </p>
                <p className="footer_small_text opacity05">{PHONE_NUMBER}</p>
              </div>
            </div>
            <div className="footer_collunm opacity08">
              <div className="footer_pay_desctop">
                <div className="footer_row">
                  <img
                    className="foot_payment_item pay-alfa"
                    alt=""
                    src={PayAlfa}
                  />
                  <img
                    className="foot_payment_item pay-visa"
                    alt=""
                    src={PayVisa}
                  />
                  <img
                    className="foot_payment_item pay-visa-secure"
                    alt=""
                    src={PayVisaSecure}
                  />
                  <img
                    className="foot_payment_item pay-id-check"
                    alt=""
                    src={PayIdCheck}
                  />
                  <img
                    className="foot_payment_item pay-mastercard"
                    alt=""
                    src={PayMaster}
                  />
                </div>
                <div className="footer_row">
                  <img
                    className="foot_payment_item pay-belcard"
                    alt=""
                    src={PayBelcard}
                  />
                  <img
                    className="foot_payment_item pay-ya"
                    alt=""
                    src={PayYa}
                  />
                  <img
                    className="foot_payment_item pay-bel"
                    alt=""
                    src={PayBel}
                  />
                  <img
                    className="foot_payment_item pay-samsung"
                    alt=""
                    src={PaySamsung}
                  />
                  <img
                    className="foot_payment_item pay-apple"
                    alt=""
                    src={payApple}
                  />
                </div>
              </div>
              {/* tablet */}
              <div className="footer_pay_tablet">
                <div className="footer_row">
                  <img
                    className="foot_payment_item pay-alfa"
                    alt=""
                    src={PayAlfa}
                  />
                  <img
                    className="foot_payment_item pay-visa"
                    alt=""
                    src={PayVisa}
                  />
                  <img
                    className="foot_payment_item pay-visa-secure"
                    alt=""
                    src={PayVisaSecure}
                  />
                </div>
                <div className="footer_row">
                  <img
                    className="foot_payment_item pay-id-check"
                    alt=""
                    src={PayIdCheck}
                  />
                  <img
                    className="foot_payment_item pay-mastercard"
                    alt=""
                    src={PayMaster}
                  />
                  <img
                    className="foot_payment_item pay-belcard"
                    alt=""
                    src={PayBelcard}
                  />
                </div>
                <div className="footer_row">
                  <img
                    className="foot_payment_item pay-ya"
                    alt=""
                    src={PayYa}
                  />
                  <img
                    className="foot_payment_item pay-bel"
                    alt=""
                    src={PayBel}
                  />
                  <img
                    className="foot_payment_item pay-samsung"
                    alt=""
                    src={PaySamsung}
                  />
                  <img
                    className="foot_payment_item pay-apple"
                    alt=""
                    src={payApple}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="footer_row footer_third_row">
            <div className="footer_collunm">
              <div className="footer_small_text opacity05">{CONSULT_HOURS}</div>
            </div>
            <div className="footer_collunm">
              <div className="footer_copyright footer_small_text opacity05">
                {TOUR_HUNTER}
                &nbsp; &copy; &nbsp;
                {getCurrentYear()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
